<template>
  <div class="app-scrollbar" @scroll="$emit('scroll', $event)">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AppScrollbar'
}
</script>

<style scoped>
.app-scrollbar {
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: #409eff rgba(220, 223, 230, 0.5);
}

.app-scrollbar::-webkit-scrollbar {
  width: 7px;
}

.app-scrollbar::-webkit-scrollbar-track {
  background: rgba(220, 223, 230, 0.5);
  border-radius: 7px;
}

.app-scrollbar::-webkit-scrollbar-thumb {
  background: #409eff;
  border-radius: 7px;
}

.app-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #66b1ff;
}
</style>
